import axiosRequest from "./axios.config";

export const createCredit = async ({ coupon }) =>
  await axiosRequest.post(`/v1/coupons/claim`, { coupon });
